import React from "react";
import "./About.css";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-xs-12">
            <div className="section-title text-center">
              <h2>About ReCoPilot</h2>
              <p>意思決定を支援するAIパートナー</p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="row main-content">
          <div className="col-xs-12 col-md-6">
            <img src="img/about.jpg" className="img-responsive about-image" alt="ReCoPilot About" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h3 className="about-subtitle">私たちのミッション</h3>
              <p className="mission-text">
                <strong>ReCoPilot</strong>は「レコメンド」をする「コパイロット」を意味します。
                人口減少が進む日本において、<span className="highlight">生産性向上</span>は不可欠な課題です。
              </p>
              <p className="description-text">
                私たちは生産性を「<span className="highlight">意思決定と実行のスピード</span>」と定義し、
                業界特化の情報を網羅的に収集・分析することで、
                従来の意思決定工数を大幅に削減することを目指しています。
              </p>
              
              <div className="cta-section">
                <p className="cta-text">
                  <strong>「人手が足りない」「調査・分析に時間がかかりすぎる」</strong><br />
                  そんなお悩みがございましたら、ぜひ一度お話しさせてください。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="row why-section">
          <div className="col-xs-12">
            <h3 className="why-title">なぜReCoPilotなのか？</h3>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="why-column">
              <h4 className="column-title">🚀 技術的優位性</h4>
              <div className="list-style">
                {props.data?.Why && props.data.Why.map((item, index) => (
                  <div key={index} className="why-item">
                    <i className="fa fa-check-circle"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="why-column">
              <h4 className="column-title">💼 ビジネス価値</h4>
              <div className="list-style">
                {props.data?.Why2 && props.data.Why2.map((item, index) => (
                  <div key={index} className="why-item">
                    <i className="fa fa-check-circle"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Stats or Call to Action */}
        <div className="row stats-section">
          <div className="col-xs-12 col-md-4">
            <div className="stat-item">
              <div className="stat-number">50%+</div>
              <div className="stat-label">工数削減</div>
            </div>
          </div>
          <div className="col-xs-12 col-md-4">
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">情報監視</div>
            </div>
          </div>
          <div className="col-xs-12 col-md-4">
            <div className="stat-item">
              <div className="stat-number">多業界</div>
              <div className="stat-label">対応実績</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
